module.exports = __webpack_public_path__ + "static/media/assignment_turned_in_black_24dp.dbe13a6a.svg";